// =============================================
// Header slots — a page puts its breadcrumbs (left) and small controls (far right) INTO
// the dashboard header, so the title, breadcrumbs and search share ONE row instead of
// the breadcrumbs taking a row of their own.
//
// Desktop only: on a phone the header has no room, so the content stays where the page
// wrote it (`useHeaderSlot` returns null and <HeaderLeft> renders its children in place).
// The slot elements live in DashboardLayout (#dashboard-header-left / -end).
// =============================================
import React, { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export const HEADER_LEFT_ID = 'dashboard-header-left';
export const HEADER_END_ID = 'dashboard-header-end';

const DESKTOP = '(min-width: 769px)';

/** The header slot element to portal into, or null (phone, or no dashboard header). */
export function useHeaderSlot(id: string): HTMLElement | null {
  const [target, setTarget] = useState<HTMLElement | null>(null);
  useLayoutEffect(() => {
    const mq = window.matchMedia(DESKTOP);
    const update = () => setTarget(mq.matches ? document.getElementById(id) : null);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, [id]);
  return target;
}

/** Breadcrumbs: shown at the left of the header row (in place on a phone). */
export const HeaderLeft: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const target = useHeaderSlot(HEADER_LEFT_ID);
  return target ? createPortal(children, target) : <>{children}</>;
};
